import React, { FC } from 'react';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import ReviewHeader from '../ReviewHeader';
import ReviewContent from '../ReviewContent';
import { Box, Typography, useTheme } from '@mui/material';
import ReviewFooter from '../ReviewFooter';
import ReviewWrapper from '../ReviewWrapper';
import { Person } from '@mui/icons-material';
import { CommunityManagement } from '../../../shared/interfaces/ICommunityManagement';
import ReviewText from '../ReviewText';

interface Props extends IReviewNewProps {}

const Check24Review: FC<Props> = ({
  communityManagement,
  commentingModule,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();

  const { username, header, text, rating, companyComment } = reviewEntry.review;

  return (
    <ReviewWrapper
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={rating}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      {username && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <Person fontSize="small" />
          <Typography
            variant="body1"
            sx={{ ml: theme.spacing(1) }}
          >
            {username}
          </Typography>
        </Box>
      )}
      {header && (
        <Typography
          variant="h6"
          sx={{
            mt: theme.spacing(2),
          }}
        >
          {header}
        </Typography>
      )}
      <ReviewText text={text} />
    </ReviewWrapper>
  );
};

export default Check24Review;
